import type { UIMessage } from "ai";

export const WRITE_APPROVAL_AUTO_CONTINUE_MESSAGE_METADATA = {
  uiHidden: true,
  source: "autoContinueTextOnlyWriteProposal",
} as const;

export const WRITE_APPROVAL_CHOICE_MESSAGE_METADATA = {
  uiHidden: true,
  source: "writeApprovalChoice",
} as const;

/** Matches all four write-assistant AUTO_CONTINUE_FOR_APPROVAL_PROMPT strings. */
const AUTO_CONTINUE_PROMPT_TEXT =
  /^Invoke .+ now with the exact values from your last proposal so the UI can show approval\.$/;

function userMessageText(message: UIMessage): string {
  return message.parts
    .filter((part): part is Extract<UIMessage["parts"][number], { type: "text" }> => part.type === "text")
    .map((part) => part.text)
    .join("\n\n")
    .trim();
}

function hasUiHiddenMetadata(metadata: unknown): boolean {
  if (metadata == null || typeof metadata !== "object") return false;
  return (metadata as Record<string, unknown>).uiHidden === true;
}

/** User turns hidden from chat UI (auto-continue, Create/Reject choice) but kept in message history. */
export function isHiddenChatUiMessage(message: UIMessage): boolean {
  if (message.role !== "user") return false;
  if (hasUiHiddenMetadata(message.metadata)) return true;
  return AUTO_CONTINUE_PROMPT_TEXT.test(userMessageText(message));
}

/** @deprecated Use isHiddenChatUiMessage */
export function isWriteApprovalAutoContinueUserMessage(message: UIMessage): boolean {
  return isHiddenChatUiMessage(message);
}
